// planPermissions.js - Control de acceso por planes

export const PLAN_PERMISSIONS = {
    MENOR: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
        'Calendario',
       // 'Aprende a Licitar',
       // 'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ], 
    PAC: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
        'PAC',
        'Tutoriales',
        'Aprende a Licitar',
        'Predicción con IA',
        'Calendario',
        'Catálogo de Proveedores'
    ],
    PREMIUM: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
        'SEACE',
        'Calendario',
       // 'Aprende a Licitar',
       // 'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ],
    // ✅ PLAN PLUS+ - Igual que PREMIUM (Plan Plus) pero con acceso intrínseco
    // al Generador de Oferta dentro de SEACE (ver hasGeneradorAccess).
    PLUS_PLUS: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
        'SEACE',
        'Calendario',
        'Aprende a Licitar',
        'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ],
    // ✅ ROL CURSO - Mismos permisos que PREMIUM
    CURSO: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
        'SEACE',
        'Calendario',
        //'Talleres',
       // 'Aprende a Licitar',
        'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ],
    // ✅ NUEVO ROL MENORES_OLD - Acceso solo a versión antigua de Contratos Menores
    MENORES_OLD: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
       // 'Contratos Menores (Old)',
        'SEACE',
        'Calendario',
        'Aprende a Licitar',
        'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ],
    // ✅ NUEVO ROL MAYORES_OLD - Acceso a versiones antiguas de SEACE y Menores
    MAYORES_OLD: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
      //  'Contratos Menores (Old)',
        'SEACE',
        'Calendario',
        'Aprende a Licitar',
        'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ],
    PRUEBA: [
        'Dashboard',
        'Estadísticas',
        'Contratos menores (Prueba)',
        'SEACE Prueba',
        'Calendario',
        'Aprende a Licitar',
        'Predicción con IA',
        'Tutoriales',
        'Catálogo de Proveedores'
    ],
    ADMI: [
        'Dashboard',
        'Estadísticas',
        'Contratos Menores',
        //'Contratos Menores (Old)',
        'SEACE',
       // 'Cursos',
       // 'Aprende a Licitar',
        'Calendario',
        'Tutoriales',
      //  'Talleres',
        'Catálogo de Proveedores',
       // 'Recursos Útiles',
        'Predicción con IA',
        // «Seguimiento de Pagos» ya está en SECCIONES_LIBRES: se deja listada
        // porque el administrador es el único sin cupo diario (ver
        // LIMITES_PAGOS_DIA).
        'Seguimiento de Pagos',
        'Administración'
    ]
};

// Nombre de sección de «Contratos Menores · Convocatorias Vigentes». Es sección
// aparte del módulo «Contratos Menores» justamente para poder abrirla sola.
export const SECCION_MENORES_VIGENTES = 'Contratos Menores · Vigentes';

// Nombre de «Trabaja para el Estado» (convocatorias de empleo público). NO va
// en SECCIONES_LIBRES: por decisión de producto la ven todos los planes menos
// el Básico (MENOR), así que se lista plan por plan en PLAN_PERMISSIONS. Para
// el plan Curso eso significa que la ve quien tenga un grupo con perfil
// distinto de MENOR, que es justo lo que se busca.
export const SECCION_TRABAJA_ESTADO = 'Trabaja para el Estado';

// Planes que NO ven «Trabaja para el Estado». Hoy solo el Básico.
export const PLANES_SIN_TRABAJA_ESTADO = ['MENOR'];

// Se agrega acá en vez de repetir la cadena en las ocho listas de arriba: así
// no hay forma de que una quede desactualizada al tocar los planes, y la regla
// («todos menos el Básico») se lee de un golpe.
//
// Ojo con el plan Curso: sus accesos salen de los perfiles de sus grupos
// (`resolverPermisos`), así que un alumno con grupo de perfil MENOR tampoco la
// ve — que es justo lo que se quiere.
Object.keys(PLAN_PERMISSIONS).forEach((plan) => {
    if (!PLANES_SIN_TRABAJA_ESTADO.includes(plan)) {
        PLAN_PERMISSIONS[plan].push(SECCION_TRABAJA_ESTADO);
    }
});

// Secciones abiertas: no pasan por el plan del usuario. "Análisis de Competidor"
// solo lee la ficha pública de un proveedor en el OECE, así que está disponible
// para todos los planes, incluidos los códigos que no figuran arriba.
// «Contratos Menores · Vigentes» va aquí por decisión de producto: las
// convocatorias abiertas a cotización se muestran a todos los planes, aunque el
// resto del módulo de menores siga siendo de pago.
// «Seguimiento de Pagos» también: lo que la distingue es que el plan no decide
// si entra, sino cuántas consultas al MEF puede hacer al día
// (LIMITES_PAGOS_DIA). El puente sigue siendo un solo equipo y su IP es el
// permiso que el MEF nos da, así que el uso se raciona en vez de cerrarse.
export const SECCIONES_LIBRES = [
    'Análisis de Competidor',
    'Seguimiento de Pagos',
    SECCION_MENORES_VIGENTES
];

// Perfiles de acceso que puede tener un grupo del plan Curso. El grupo no define
// permisos propios: apunta a uno de los planes de arriba. Así "Grupo 16 - Contratos
// Menores" da el acceso básico y "Contratos Mayores" da el Plus (menores + SEACE),
// sin tocar PLAN_PERMISSIONS.
export const PERFILES_GRUPO_CURSO = [
    { code: 'MENOR',     label: 'Básico — Contratos Menores' },
    { code: 'PREMIUM',   label: 'Plus — Contratos Menores + SEACE' },
    { code: 'PLUS_PLUS', label: 'Plus+ — Todo + Generador de Oferta' },
    { code: 'PAC',       label: 'PAC — Plan Anual de Contrataciones' },
    { code: 'CURSO',     label: 'Completo (como hasta ahora)' }
];

// Los grupos a los que pertenece un usuario. curso_tipo puede traer varios
// separados por coma: "GRUPO_1_MENORES, GRUPO_2_SEACE".
export const parseGruposCurso = (cursoTipo) => String(cursoTipo || '')
    .split(',')
    .map(g => g.trim().toUpperCase())
    .filter(Boolean);

// Perfil de un grupo según el catálogo del admin. Un grupo desconocido o sin
// perfil se comporta como hasta ahora (plan CURSO completo), para que nadie
// pierda accesos el día del despliegue.
export const perfilDeGrupo = (nombreGrupo, gruposCurso = []) => {
    const buscado = String(nombreGrupo || '').trim().toUpperCase();
    const grupo = (gruposCurso || []).find(
        g => String(g?.nombre || '').trim().toUpperCase() === buscado
    );
    const perfil = String(grupo?.perfil || '').trim().toUpperCase();
    return PLAN_PERMISSIONS[perfil] ? perfil : 'CURSO';
};

// ==========================================================
// Cupo diario de Seguimiento de Pagos
// ==========================================================
// Consultas al MEF que puede hacer cada plan en un día (hora de Lima). `null`
// es sin límite. Estos números están acá solo para los textos de la pantalla
// («te queda 1 de 3», «con el Plan Premium serían 5»): quien decide de verdad
// es la función `limite_consultas_mef` de Supabase, porque el navegador no
// puede llevar su propia cuenta. Si se cambia un cupo, hay que cambiarlo en
// los dos sitios (supabase/migrations/202610200001_cuota_pagos_mef.sql).
export const LIMITE_PAGOS_POR_DEFECTO = 1;

export const LIMITES_PAGOS_DIA = {
    ADMI: null,
    PLUS_PLUS: 5,
    PREMIUM: 3
};

// Cupo del plan de un usuario. Para CURSO manda el perfil de sus grupos (el más
// alto, si está en varios), igual que los accesos.
export const limitePagosDia = (userPlan, cursoTipo, gruposCurso = []) => {
    const plan = String(userPlan || '').trim().toUpperCase();
    if (plan in LIMITES_PAGOS_DIA) return LIMITES_PAGOS_DIA[plan];
    if (plan !== 'CURSO') return LIMITE_PAGOS_POR_DEFECTO;

    return parseGruposCurso(cursoTipo).reduce((mayor, nombre) => {
        const perfil = perfilDeGrupo(nombre, gruposCurso);
        const cupo = LIMITES_PAGOS_DIA[perfil];
        // El perfil CURSO (acceso completo) no suma cupo: no es un plan pagado
        // más alto, es el comodín de los grupos sin perfil asignado.
        return typeof cupo === 'number' ? Math.max(mayor, cupo) : mayor;
    }, LIMITE_PAGOS_POR_DEFECTO);
};

// Secciones que ve de verdad un usuario. Para todos los planes salvo CURSO es la
// lista de PLAN_PERMISSIONS de siempre; para CURSO es la unión de los perfiles de
// sus grupos (si está en dos grupos, suma los dos accesos).
export const resolverPermisos = (userPlan, cursoTipo, gruposCurso = []) => {
    const plan = String(userPlan || '').trim().toUpperCase();
    if (plan !== 'CURSO') return PLAN_PERMISSIONS[plan] || [];

    const grupos = parseGruposCurso(cursoTipo);
    if (grupos.length === 0) return PLAN_PERMISSIONS.CURSO;

    const secciones = new Set();
    grupos.forEach(nombre => {
        const perfil = perfilDeGrupo(nombre, gruposCurso);
        (PLAN_PERMISSIONS[perfil] || []).forEach(seccion => secciones.add(seccion));
    });
    return Array.from(secciones);
};

export const hasMenuAccess = (userPlan, menuLabel, cursoTipo, gruposCurso) => {
    if (!menuLabel) return false;
    if (SECCIONES_LIBRES.includes(menuLabel)) return true;
    if (!userPlan) return false;

    return resolverPermisos(userPlan, cursoTipo, gruposCurso).includes(menuLabel);
};

// Planes que el administrador puede habilitar/deshabilitar para accesos
// configurables (ej: Generador de Oferta). ADMI y PLAN PLUS+ no se listan
// porque siempre tienen acceso al Generador de Oferta.
export const PLANES_ASIGNABLES = [
    { code: 'MENOR',        label: 'Contratos Menores' },
    { code: 'PAC',          label: 'Plan PAC' },
    { code: 'PREMIUM',      label: 'Plan Plus' },
    { code: 'CURSO',        label: 'Plan Curso' },
    { code: 'MENORES_OLD',  label: 'Contratos Menores (Old)' },
    { code: 'MAYORES_OLD',  label: 'Contratos Mayores (Old)' },
    { code: 'PRUEBA',       label: 'Periodo de prueba' }
];

// Determina si un usuario tiene acceso a un feature configurable (ej: Generador
// de Oferta) según los planes habilitados por el admin.
//
// La lista de habilitados puede contener:
//  - Códigos de plan simples: 'MENOR', 'PAC', 'PREMIUM', ...
//  - 'CURSO'            → todos los grupos del plan Curso
//  - 'CURSO:<GRUPO>'    → solo ese grupo de curso (según el curso_tipo del usuario)
//
// cursoTipo es el campo curso_tipo del usuario (puede traer varios grupos
// separados por coma: "GRUPO_1_MENORES, GRUPO_2_SEACE"). gruposCurso es el
// catálogo del admin, necesario porque un grupo con perfil PLUS_PLUS lleva el
// Generador de Oferta incluido sin pasar por la pestaña de accesos.
export const hasGeneradorAccess = (userPlan, cursoTipo, planesHabilitados = [], gruposCurso = []) => {
    const planUpper = String(userPlan || '').trim().toUpperCase();
    // ADMI y PLAN PLUS+ tienen acceso intrínseco al Generador de Oferta.
    if (planUpper === 'ADMI' || planUpper === 'PLUS_PLUS') return true;

    const habilitados = (planesHabilitados || []).map(p => String(p).trim().toUpperCase());

    if (planUpper !== 'CURSO') {
        return habilitados.includes(planUpper);
    }

    // Plan CURSO: acceso total ('CURSO') o por grupo específico ('CURSO:<GRUPO>')
    if (habilitados.includes('CURSO')) return true;
    const grupos = parseGruposCurso(cursoTipo);
    return grupos.some(g =>
        habilitados.includes(`CURSO:${g}`) ||
        perfilDeGrupo(g, gruposCurso) === 'PLUS_PLUS'
    );
};
// ==========================================================
// Nombre visible del plan
// ==========================================================
// Única fuente de los nombres que ve el usuario: la insignia de la barra
// superior, el menú de «Mi cuenta», el sidebar y el modal de planes leen de
// acá. Antes cada pantalla tenía su propio mapa y la que no conocía un código
// lo resolvía a su manera: un alumno (plan CURSO) veía «Sin plan registrado»
// arriba, «CURSO» en su menú y «Plan Curso» en el sidebar.
export const NOMBRES_PLAN = {
    MENOR: 'Plan Básico',
    PAC: 'Plan PAC',
    PREMIUM: 'Plan Plus',
    PLUS_PLUS: 'Plan Premium',
    CURSO: 'Plan Curso',
    MENORES_OLD: 'Contratos Menores (Old)',
    MAYORES_OLD: 'Contratos Mayores (Old)',
    PRUEBA: 'Periodo de prueba',
    ADMI: 'Administrador'
};

// Para quedarse con el acceso más alto cuando el alumno está en varios grupos
// (menores + mayores → manda mayores). PAC va al mismo nivel que el básico:
// no es más acceso, es otro.
const RANGO_PERFIL = { MENOR: 1, PAC: 1, PREMIUM: 2, PLUS_PLUS: 3 };

// Los grupos de antes de la pestaña de perfiles no traen `perfil` (y algunos ya
// no están en el catálogo). Para esos la única pista es el nombre del grupo, y
// alcanza: todos se llaman «…CONTRATOS_MENORES» o «…CONTRATOS_MAYORES».
const perfilPorNombreDeGrupo = (nombreGrupo) => {
    const nombre = String(nombreGrupo || '').toUpperCase();
    if (nombre.includes('MAYOR') || nombre.includes('AMBOS')) return 'PREMIUM';
    if (nombre.includes('MENOR')) return 'MENOR';
    return null;
};

// Plan al que equivale el curso de un alumno: el de contratos menores es el
// Plan Básico y el de contratos mayores el Plan Plus. Manda el perfil que el
// admin le puso al grupo; si el grupo no tiene perfil, se deduce del nombre.
// Devuelve null cuando no hay con qué decidir (sin grupo, o uno que no dice de
// qué curso es).
export const planEquivalenteCurso = (cursoTipo, gruposCurso = []) =>
    parseGruposCurso(cursoTipo).reduce((masAlto, nombre) => {
        const delCatalogo = perfilDeGrupo(nombre, gruposCurso);
        // 'CURSO' es el comodín de los grupos sin perfil: no dice nada del plan.
        const perfil = delCatalogo === 'CURSO' ? perfilPorNombreDeGrupo(nombre) : delCatalogo;
        if (!RANGO_PERFIL[perfil]) return masAlto;
        return !masAlto || RANGO_PERFIL[perfil] > RANGO_PERFIL[masAlto] ? perfil : masAlto;
    }, null);

// Nombre del plan tal como se le muestra al usuario. Un alumno del plan Curso
// ve el plan al que equivale su grupo, no la palabra «Curso».
export const nombrePlan = (userPlan, cursoTipo, gruposCurso = []) => {
    const plan = String(userPlan || '').trim().toUpperCase();
    if (!plan) return NOMBRES_PLAN.MENOR;
    if (plan === 'CURSO') {
        return NOMBRES_PLAN[planEquivalenteCurso(cursoTipo, gruposCurso)] || NOMBRES_PLAN.CURSO;
    }
    // Un código que no esté en el mapa se muestra tal cual: es raro, pero sirve
    // para soporte y nunca alarma al usuario como «Sin plan registrado».
    return NOMBRES_PLAN[plan] || plan;
};

// Código de plan con el que comparar para marcar «este es tu plan» o pintar la
// insignia: el del usuario, salvo en Curso, donde manda el plan equivalente.
export const codigoPlanVisible = (userPlan, cursoTipo, gruposCurso = []) => {
    const plan = String(userPlan || '').trim().toUpperCase();
    if (plan !== 'CURSO') return plan;
    return planEquivalenteCurso(cursoTipo, gruposCurso) || 'CURSO';
};
